import { Colors } from '@/common/colors/colors';
import {
	handleCronChange,
	handleDisplayCron,
} from '@/common/functions/cronTransformer';
import { RedSspan } from '@/common/styles/RedSpan';
import Cron from 'react-js-cron';
import { CronContainer, InfoText } from './CronInput.styled';

const CronInput = ({ cron, setCron, required, width = 500 }) => {
	const exampleDate = new Date();
	exampleDate.setUTCHours(10);

	const handleSetValue = (newCron) => {
		setCron(handleCronChange(newCron));
	};

	return (
		<CronContainer style={{ width: `${width}px` }}>
			<label
				style={{
					textAlign: 'right',
					fontSize: `18px`,
				}}
			>
				<strong>
					<span style={{ color: Colors.darkBlue }}>
						Cron: {required && <RedSspan>*</RedSspan>}
					</span>
				</strong>
			</label>
			<Cron
				clearButtonProps={{
					style: {
						backgroundColor: 'transparent',
						border: '1px solid orange',
						boxShadow: 'none',
						color: 'orange',
						fontWeight: 'bold',
						borderRadius: 10,
					},
				}}
				value={handleDisplayCron(cron)}
				setValue={handleSetValue}
			/>
			<InfoText>
				<p>INFO: Schedules like "Everyday at 10:00" are in UTC (+0h).</p>
				<p>
					Example: {exampleDate.getUTCHours()}:00 in UTC ={' '}
					{exampleDate.getHours()}:00 in Warsaw
				</p>
			</InfoText>
		</CronContainer>
	);
};

export default CronInput;
